import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function Karriere() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-247">
      <Navigation data-id="element-248" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-249">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz" data-id="element-250">
          Karriere
        </h1>
      </main>
      <Footer data-id="element-251" />
    </div>;
}